///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.common = {
    formBuilder: null,

    showHelpModal: true,

    init() {
        // Init CKEditor
        $('textarea.ckeditor').toArray().forEach(element => CKEDITOR.create(element, CKEDITOR.config));

        if(abcsetup.userRole.class == 'private_label_team') {
            $('#template-name').closest('.col-8.text-left').css("display", "none");
            $('#preview-modal-btn').css("display", "none");
            $('.preview_cancel').removeClass('col-4').addClass('col-12');
        }

        this._setupFormBuilder();
    },

    setupEventBindings() {
        // Update item sub lists when items list changes
        $('#app_a_b_c_item__item_ids,#app_models_consumer_r_f_p_item__custom_item_descriptions').on('change', () => {
            this._syncItemSetupDeadlines();
            this._syncItemInventoryDeadlines();
            this._syncEstimatedUpcomingVolumes();
            this._syncActiveIngredients();
            this._syncCompareTos();
        }).trigger('change');

        // Toggle disabled on supplier selects when all suppliers checked or unchecked.
        $('#app_models_consumer_r_f_p__all_suppliers').on('change', event => {
            $('#app_models_consumer_r_f_p_supplier__supplier_ids')
                .toggleClass('disabled', $(event.target).prop('checked'))
                .attr('disabled', $(event.target).prop('checked'));
        }).trigger('change');

        // Toggle custom fields visibility
        $('#app_models_consumer_r_f_p__consumer_rfp_type_id').on('change', event => {
            const customFields = $('#custom_fields');
            const itemSelection = $('#items-wrapper');
            const contractTerms = $('#contract-terms-wrapper');

            customFields.toggle(customFields.data('typesAllowCustomFields')[event.target.value]);
            itemSelection.toggle(itemSelection.data('typesAllowItemSelection')[event.target.value]);
            contractTerms.toggle(itemSelection.data('typesAllowItemSelection')[event.target.value]);
            $('#active_ingredient_table').closest('.col-sm-6').show();

            if(event.target.value == 4 || event.target.value == 8) {
                $('#date-wrapper').hide();
                $('#rfi-reminder-wrapper').show();
                $('#rfi-reminder-wrapper').find('input').attr('disabled',false);
                $('#rfi-reminder-wrapper').find('input').attr('required',true);
                $('#date-wrapper').find('input').attr('required', false);
            }
            else if(event.target.value == 3) {
                $('.import-download').hide();
                $('#import_text').hide();
                $('.btn-item-selector').addClass('rounded');
                $('#date-wrapper').show();
                $('#date-wrapper').find('input').attr('required', true);
                $('#rfi-reminder-wrapper').hide();
                $('#rfi-reminder-wrapper').find('input').attr('disabled',true);
                $('#rfi-reminder-wrapper').find('input').attr('required',true);
            }
            else if(event.target.value == 7) {
                $('.import-download').hide();
                $('.btn-item-selector').addClass('rounded');
                $('#date-wrapper').show();
                $('#date-wrapper').find('input').attr('required', true);
                $('#rfi-reminder-wrapper').hide();
                $('#rfi-reminder-wrapper').find('input').attr('disabled',true);
                $('#rfi-reminder-wrapper').find('input').attr('required',true);
                $('#active_ingredient_table').closest('.col-sm-6').hide();
            }
            else {
                $('#date-wrapper').show();
                $('#date-wrapper').find('input').attr('required', true);
                $('#rfi-reminder-wrapper').hide();
                $('#rfi-reminder-wrapper').find('input').attr('disabled',true);
                $('#rfi-reminder-wrapper').find('input').attr('required',true);
            }

        }).trigger('change');

        // Open the item search window when the search button is pressed.
        $(document).on('click', '.btn-item-selector', () => abcsetup.launchWin('/consumer_rfp/item/item_selector', 'item_selector'));

        // Handle submit
        $(document).on('submit', '.consumer_rfp_form', () => {
            // Capture custom fields if necessary
            $('#custom_fields > .fields_data').val(JSON.stringify(this.formBuilder.actions.getData()));
        });
    },

    /**
     * Process an import of suppliers.
     *
     * @param {{key:int, label:string}[]} suppliers
     */
    importSuppliers(suppliers) {
        if (!suppliers.length) {
            abcsetup.alerts.show('No suppliers found', '<div class="alert alert-danger text-center">No suppliers were found in the specified import file</div>');
            return;
        }

        this.appendSuppliers(suppliers);

        abcsetup.alerts.show('Supplier import', '<div class="alert alert-success text-center"><b>' + suppliers.length + ' suppliers</b> were successfully imported</div>');
    },

    /**
     * Append suppliers to the invited existing suppliers list.
     *
     * @param {{key:int, label:string}[]} suppliers
     */
    appendSuppliers(suppliers) {
        if ($('#app_models_consumer_r_f_p__all_suppliers').prop('checked')) {
            $('#app_models_consumer_r_f_p__all_suppliers').prop('checked', false).trigger('change');
        }

        $('#app_models_consumer_r_f_p_supplier__supplier_ids')
            .val(suppliers.map(supplier => supplier.key))
            .trigger('change');
    },

    /**
     * Process an import of items.
     *
     * @param {{key:int, label:string}[]} items
     * @param {{abc_item_id:int, ...}[]} extras
     */
    importItems(items, extras) {
        if (!items.length) {
            abcsetup.alerts.show('No items found', '<div class="alert alert-danger text-center">No items were found in the specified import file</div>');
            return;
        }

        this.appendItems(items, extras);

        abcsetup.alerts.show('Item import', '<div class="alert alert-success text-center"><b>' + items.length + ' items</b> were successfully imported</div>');
    },

    /**
     * Append items to the items up for bid list.
     *
     * @param {{key:int, label:string}[]} items
     * @param {{abc_item_id:int, ...}[]} extras
     */
    appendItems(items, extras) {
        const itemsSelect = $('#app_a_b_c_item__item_ids');

        items.forEach(item => {
            // Toggle the existing item or add it
            if (itemsSelect.find(`option[value=${item.key}]`).length) {
                itemsSelect.find(`option[value=${item.key}]`).prop('selected', true);
            } else {
                const newOption = new Option(item.label, String(item.key), true, true);
                itemsSelect.append(newOption);
            }
        });

        itemsSelect.trigger('change');

        const itemSetupDeadlineTable = $('#item_setup_deadline_table');
        const itemInventoryDeadlineTable = $('#item_inventory_deadline_table');
        const estimatedUpcomingVolumeTable = $('#estimated_upcoming_volume_table');
        const activeIngredientTable = $('#active_ingredient_table');
        const compareToTable = $('#compare_to_table');
        extras.forEach(extra => {
            itemSetupDeadlineTable.find(`tr.consumer_rfp_item_real_${extra.abc_item_id} input`).val(extra.item_setup_deadline_date).trigger('change');
            itemInventoryDeadlineTable.find(`tr.consumer_rfp_item_real_${extra.abc_item_id} input`).val(extra.item_inventory_deadline_date).trigger('change');
            estimatedUpcomingVolumeTable.find(`tr.consumer_rfp_item_real_${extra.abc_item_id} input`).val(extra.estimated_upcoming_volume_value).trigger('change');
            activeIngredientTable.find(`tr.consumer_rfp_item_real_${extra.abc_item_id} input`).val(extra.active_ingredient_value).trigger('change');
            compareToTable.find(`tr.consumer_rfp_item_real_${extra.abc_item_id} input`).val(extra.compare_to_value).trigger('change');
        });
    },

    /**
     * Update the item setup deadline table
     */
    _syncItemSetupDeadlines() {
        this._syncItemMetaDataTable($('#item_setup_deadline_table'), 'item_setup_deadline');
    },

    /**
     * Update the item inventory deadline table
     */
    _syncItemInventoryDeadlines() {
        this._syncItemMetaDataTable($('#item_inventory_deadline_table'), 'item_inventory_deadline');
    },

    /**
     * Update the item estimated upcoming volumes table.
     */
    _syncEstimatedUpcomingVolumes() {
        this._syncItemMetaDataTable($('#estimated_upcoming_volume_table'), 'estimated_upcoming_volume', false);
    },

    /**
     * Update the item active ingredient table.
     */
    _syncActiveIngredients() {
        this._syncItemMetaDataTable($('#active_ingredient_table'), 'active_ingredient', false);
    },

    /**
     * Update the item compare to table.
     */
    _syncCompareTos() {
        this._syncItemMetaDataTable($('#compare_to_table'), 'compare_to', false);
    },

    /**
     * Sync the rows in the given table with the items selected in the real items input.
     *
     * @param table
     * @param fieldName
     * @param defaultToExistingValue
     * @private
     */
    _syncItemMetaDataTable(table, fieldName, defaultToExistingValue = true) {
        const originals = table.data('originals') || {};
        // This is the value we'll copy to new items that we don't already have values for.
        const defaultValue = defaultToExistingValue ? table.find(':input').toArray().map(field => field.value).filter(Boolean).shift() : null;
        // Update the original values we have for items that were stored in the database when this page was built.
        const updateOriginals = (key, val) => {
            originals[key] = val;
            table.data('originals', originals);
        };
        // Add an item row to this table.
        const appendRow = (itemDescription, val, className, rowFieldName) => {
            const template = table.find('.template');
            const newRow = template.clone().removeClass('collapse template').addClass(className);
            newRow.find('.description').text(itemDescription);
            newRow.find('.value input').val(val).attr('name', rowFieldName);
            table.append(newRow);
        }

        // Sync the real items dropdown.
        $('#app_a_b_c_item__item_ids').val().forEach(ABCItemId => {
            const consumerRFPItemId = table.data('abcItemToConsumerRfpItemId')[ABCItemId];
            const type = 'real';
            const id = ABCItemId;
            const originalsKey = consumerRFPItemId || `${type}_${id}`
            const className = `consumer_rfp_item_${type}_${id}`;

            if (table.find(`tr.${className}`).length) {
                table.find(`tr.${className}`).addClass('valid');
                return;
            }

            const description = $('#app_a_b_c_item__item_ids option[value=' + ABCItemId + ']').text();
            const val = originals[originalsKey] || defaultValue;

            updateOriginals(originalsKey, val);
            appendRow(description, val, className, `${fieldName}[${type}][${id}]`);
        });

        $('#app_models_consumer_r_f_p_item__custom_item_descriptions').val().forEach(itemDescription => {
            const consumerRFPItemId = table.data('descriptionToConsumerRfpItemId')[itemDescription];
            const type = 'custom';
            const id = itemDescription;
            const originalsKey = consumerRFPItemId || `custom_${id}`
            // As a part of this, we're converting the item description (if working with one) to something CSS is happy with.
            const className = `consumer_rfp_item_${type}_${btoa(id).replace(/[^0-9A-Za-z_]/g, '_')}`;

            if (table.find(`tr.${className}`).length) {
                table.find(`tr.${className}`).addClass('valid');
                return;
            }

            const val = originals[originalsKey] || defaultValue;

            updateOriginals(originalsKey, val);
            appendRow(itemDescription, val, className, `${fieldName}[${type}][${id}]`);
        });

        table.find('tbody tr:not(.valid)').remove();
        table.find('tbody tr:not(.template)').removeClass('valid');
    },

    _setupFormBuilder() {
        require('formBuilder');
        require('formBuilder/dist/form-render.min');

        this.formBuilder = $('#custom_fields .form_builder').formBuilder({
            scrollToFieldOnAdd: false,
            formData: JSON.parse($('#custom_fields > .fields_data').val()),
            disabledActionButtons: ['clear', 'data', 'save'],
            disableFields: ['hidden', 'button', 'header'],
            disabledAttrs: [
                'access',
                'className',
                'name',
            ],
            disabledSubtypes: {
                textarea: ['tinymce', 'quill'],
            },
            onAddField: (fieldId,field) => {
                // hack to wait a split second while the field gets loaded and is available to recognize
                setTimeout(() => { this._customButtons() },100);

                switch(field.type) {
                    case('radio-group'):
                    case('checkbox-group'):
                    case('autocomplete'):
                    case('select'):
                        if(this.showHelpModal == true) {
                            $('#option-help-modal').modal('show');
                            this.showHelpModal = false;
                        }
                        break;
                }
            },

        });
    },

    _customButtons() {
        const formData = abcsetup.consumer_rfp.common.formBuilder.actions.getData();
        if(formData.length > 0) {
            $('#save-template-btn').prop('disabled', false);
            $('#preview-modal-btn').prop('disabled', false);
        } else {
            $('#save-template-btn').prop('disabled', true);
            $('#preview-modal-btn').prop('disabled', true);
        }
    },
};
